import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/src/app/safety-standards/components/SafetyStandardsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6955f19666cdef001454bf90/valence_solar_platform/src/components/common/Header.tsx");
